goog.provide("shadow.js.shim.module$src$svg$inform$bubble_left_text_svg$default");
shadow.js.shim.module$src$svg$inform$bubble_left_text_svg$default = shadow.js.shim.module$src$svg$inform$bubble_left_text_svg.default;
